import { useCallback, useEffect, useState } from 'react'

/**
 * A submission sent over a socket that hasn't come back yet. It clears when
 * `arrived` turns true, or after `timeoutMs` in case it never does.
 */
export function usePendingSubmission(arrived: boolean, timeoutMs = 30000) {
  const [pending, setPending] = useState(false)

  useEffect(() => {
    if (arrived) setPending(false)
  }, [arrived])

  useEffect(() => {
    if (!pending) return
    const timer = setTimeout(() => setPending(false), timeoutMs)
    return () => clearTimeout(timer)
  }, [pending, timeoutMs])

  const start = useCallback(() => setPending(true), [])
  const clear = useCallback(() => setPending(false), [])

  return { pending, start, clear }
}
